import request from '@/utils/request'

// 获取公众号报表
export function getList(params = {}) {
  return request({
    url: '/report_form/wechat_form_groups',
    method: 'get',
    params
  })
}

// 获取公众号报表
export function modifyConsumption(data = {}) {
  return request({
    url: '/report_form/wechat_form_group/set_consume',
    method: 'PUT',
    data
  })
}

// 导出公众号报表
export function exportOfficialAccountReport(data = {}) {
  return request({
    url: '/report_form/wechat_form_group/export_data',
    method: 'post',
    data
  })
}
